import { ContextWrapper } from '@common/contexts/ContextWrapper';
import { LocationStore } from '@hospital/views/admin/locations/LocationStore';


export const LocationStoreContextWrapper = new ContextWrapper<LocationStore>();
